import { useState } from "react";
import VoiceAgent from "./VoiceAgent";

import "./MiaInlineWidget.css";
import { createMiaSession } from "adapters/form.service";

const DEFAULT_CONFIG = {
  tenantId: "cr-ai-research-h7igh",
  formId: "Questionnaire/842d26e6-5cda-4776-9a67-dc3beadd462a",
  formUrl: "",
  patientName: "Maria Lopez",
  dateOfBirth: "",
  patientGender: "",
  agentName: "Mia",
  selectedLanguage: "en-US",
  mode: "voice",
  serviceConfig: undefined,
};

export default function MiaInlineWidget({
  tenantId = DEFAULT_CONFIG.tenantId,
  formId = DEFAULT_CONFIG.formId,
  formUrl = DEFAULT_CONFIG.formUrl,
  patientName = DEFAULT_CONFIG.patientName,
  dateOfBirth = DEFAULT_CONFIG.dateOfBirth,
  patientGender = DEFAULT_CONFIG.patientGender,
  agentName = DEFAULT_CONFIG.agentName,
  selectedLanguage = DEFAULT_CONFIG.selectedLanguage,
  mode = DEFAULT_CONFIG.mode,
  serviceConfig = DEFAULT_CONFIG.serviceConfig,
  wsPath = "/v1/mia/ws",
  className = "",
  style,
  setIsOnline = () => {},
  isOnline = false,
  setIsMuted = () => {},
}) {
  const [sessionId, setSessionId] = useState(null);
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState(null);

  async function handleStartSession() {
    if (!tenantId) {
      setError("Missing tenantId for MiaInlineWidget");
      return;
    }

    setError(null);
    setCreating(true);

    try {
      const data = await createMiaSession({
        tenantId,
        formId,
        formUrl,
        mode,
        patientName,
        dateOfBirth,
        patientGender,
        agentName,
        selectedLanguage,
        serviceConfig,
      });
      setSessionId(data.session_id);
    } catch (err) {
      setError(err.message || "Failed to create MIA session");
    } finally {
      setCreating(false);
    }
  }

  function handleDisconnect() {
    setSessionId(null);
    setError(null);
  }

  const rootClass = ["mia-inline-widget", className].filter(Boolean).join(" ");

  return (
    <div className={rootClass} style={style}>
      {sessionId ? (
        <VoiceAgent
          sessionId={sessionId}
          initialMode={mode}
          agentName={agentName}
          wsPath={wsPath}
          onDisconnect={handleDisconnect}
          setIsOnline={setIsOnline}
          isOnline={isOnline}
          setIsMuted={setIsMuted}
        />
      ) : (
        <div className="mia-inline-idle">
          <button
            type="button"
            className="mia-inline-mic-button"
            onClick={handleStartSession}
            disabled={creating}
            aria-label={
              creating ? "Creating MIA session" : "Start MIA voice session"
            }
          >
            <span className="mia-inline-mic-icon" aria-hidden="true">
              {/* <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />
              </svg> */}
              <svg
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z" />
              </svg>
            </span>
          </button>
          <div className="mia-inline-copy">
            <p className="mia-inline-title">Talk to Mia</p>
            <p className="mia-inline-subtitle">
              {/* {creating ? "Creating session..." : "Click the mic to start a new session"} */}
              {creating ? "Creating session..." : "Start a new session"}
            </p>
            {error && <p className="mia-inline-error">{error}</p>}
          </div>
        </div>
      )}
    </div>
  );
}
